import { FormattedMessage } from "react-intl";
import { tableColumnTypes } from "../../tableColumnTypes";
import { distribute } from "./distribute";
import { formatDate } from "./distributionHistory";
import { recallShotclasses } from "./recallShotclasses";

export let recallSelective = {
  name: <FormattedMessage id="RECALL_SELECTIVE" />,
  label: <FormattedMessage id="RECALL_SELECTIVE" />,
  path: (tenantName) =>
    `/${tenantName}/distribute/recallShotclasses/recallSelective`,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: distribute.name,
      path: distribute.path(tenantName),
      onClick: () => navigate(`${distribute.path(tenantName)}`),
    },
    {
      key: 2,
      label: recallShotclasses.label,
      path: `${recallShotclasses.path(tenantName)}`,
      onClick: () => navigate(`${recallShotclasses.path(tenantName)}`),
    },
    {
      key: 3,
      label: recallSelective.label,
      path: `${recallSelective.path(tenantName)}`,
      onClick: () => navigate(`${recallSelective.path(tenantName)}`),
    },
  ],
  columns: () => [
    {
      ID: 1,
      name: <FormattedMessage id="VisualReport_AssignedDate" />,
      fieldName: "AssignedDate",
      value: (row) => formatDate(row.AssignedDate),
      sort: false,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 2,
      name: <FormattedMessage id="DIST_HISTORY_STATUS" />,
      fieldName: "Status",
      value: (row) =>
        row.Status === "InProgress" ? "In Progress" : row?.Status,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="P_Name" />,
      fieldName: "Username",
      value: (row) => row.Username,
      sort: false,
      type: tableColumnTypes.STRING,
    },
  ],
};
